<a href="/consultar-reserva?file={{file}}&ultimonome={{ultimonome}}" class="btn-one btn-icon" target="__blank" title="Clique aqui para ir para a página Consultar Reserva">
  <i class="material-icons">search</i>
  <span>CONSULTAR RESERVA</span>
</a>